import React, { ReactElement } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Image, { ImageProps } from './Image'
import { printConfig } from '../../config'

const useStyles = makeStyles(theme => ({
  string: {
    padding: theme.spacing(0.75, 0),
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    '@media print': {
      fontFamily: printConfig.defaults.fontName,
      fontSize: printConfig.defaults.fontSize
    }
  }
}))

export interface StringItemProps {
  stringId: string
  text: string
  images: ImageProps[]
}

function StringItem({ stringId, text, images }: StringItemProps): ReactElement {
  const classes = useStyles()
  return (
    <div id={`string_${stringId}`}>
      {images.map(image => (
        <Image key={image.imageId} {...image} />
      ))}
      <Typography className={classes.string} variant="body2">
        {text}
      </Typography>
    </div>
  )
}

export default StringItem
